import { render, staticRenderFns } from "./CsoClientForm.vue?vue&type=template&id=24795476&scoped=true"
import script from "./CsoClientForm.vue?vue&type=script&lang=js"
export * from "./CsoClientForm.vue?vue&type=script&lang=js"
import style0 from "./CsoClientForm.vue?vue&type=style&index=0&id=24795476&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24795476",
  null
  
)

export default component.exports